import React, { PureComponent } from "react";
import { Doughnut } from "react-chartjs-2";
const data = {
  datasets: [
    {
      data: [10, 20, 30, 12, 44],
      backgroundColor: ["red", "blue", "green", "violet", "orange"],
    },
  ],

  // These labels appear in the legend and in the tooltips when hovering different arcs
  labels: ["Apparel", "Electronics", "Groceries", "Furniture", "Miscellaneous"],
};

const options = {
  legend: {
    display: true,
    position: "bottom",
    labels: {
      fontSize: 8,
    },
  },
  maintainAspectRatio: true,
};
export default class Distribution extends PureComponent {
  render() {
    return <Doughnut data={data} options={options} width={180} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Distribution.js